<template>
  <div class="error-page bg-surface">
    <v-empty-state
      bg-color="white"
      class="rounded"
      icon="mdi-transmission-tower-off"
      :headline="$t('AppWhoops')"
      :title="errorMessage"
      min-height="auto"
    >
      <template #actions>
        <a href="/">{{ $t('AppHome') }} </a>
      </template>
    </v-empty-state>

    <div>
      <v-expansion-panels elevation="0">
        <v-expansion-panel>
          <v-expansion-panel-title>Details</v-expansion-panel-title>
          <v-expansion-panel-text style="max-height: 30vh; overflow: auto">
            <pre style="white-space: break-spaces">{{ error }}</pre>
          </v-expansion-panel-text>
        </v-expansion-panel>
      </v-expansion-panels>
    </div>
  </div>
</template>

<script lang="ts">
import { computed, defineComponent, reactive } from 'vue'
import type { PropType } from 'vue'
import type { NuxtError } from 'nuxt/app'
import { useHead } from 'nuxt/app'
import { useI18n } from 'vue-i18n'

export default defineComponent({
  name: 'ErrorPage',
  props: {
    error: {
      type: Object as PropType<null | NuxtError>,
      default: null,
    },
  },
  setup(props) {
    const { t } = useI18n()

    const errorMessage = computed(() => {
      return props.error?.statusCode === 404 ? t('AppPageError404') : t('AppPageError')
    })

    useHead({
      title: () => errorMessage.value,
    })
    return {
      errorMessage,
    }
  },
  computed: {
    test() {
      return this.$t('test')
    },
  },
})
</script>

<style scoped>
.error-page {
  height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}
</style>
